<div class="calendar-action-form">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()" [attr.aria-label]="tornaIndietroAria">
        <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-uppercase fs-pt-16">{{ action.label }}</ion-title>
  </ion-toolbar>

  <div class="form-content">

    @if (isSospeso) {
      <ion-text color="warning" class="ion-padding-horizontal">
        <p class="fs-pt-12">{{ sospesoLabel }}</p>
      </ion-text>
    }

    <!-- Quick chips -->
    <div class="quick-chips-section">
      <p class="quick-chips-label">{{ contextQuestion }}</p>
      @if (loadingEvents) {
        <div class="chips-loader" role="status" [attr.aria-label]="disponibilitaAria">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
          <span>{{ verificaDisponibilita }}</span>
        </div>
      }
      <div class="quick-chips-days" [class.chips-hidden]="loadingEvents">
        @for (chip of dayChips; track chip.id) {
          <ion-chip
            [ngClass]="getChipCssClass(chip)"
            [disabled]="isChipDisabled(chip)"
            (click)="selectChip(chip)"
            [attr.aria-label]="getChipAriaLabel(chip)"
            [attr.aria-pressed]="chip === selectedChip"
            [attr.aria-disabled]="isChipDisabled(chip)">
            <div class="chip-content">
              <span class="chip-label">{{ chip.label }}</span>
              @if (chip.shortDate) {
                <span class="chip-date">{{ chip.shortDate }}</span>
              }
              @if (chip.stateLabel) {
                <span class="chip-state">{{ chip.stateLabel }}</span>
              }
            </div>
          </ion-chip>
        }
      </div>
      <ion-chip
        class="chip-custom"
        [class.chips-hidden]="loadingEvents"
        [ngClass]="{ 'chip-selected': customChip === selectedChip }"
        (click)="selectChip(customChip)"
        [attr.aria-label]="getChipAriaLabel(customChip)"
        [attr.aria-pressed]="customChip === selectedChip">
        <div class="chip-content">
          <span class="chip-label">{{ customChip.label }}</span>
        </div>
      </ion-chip>
    </div>

    <!-- Date picker (on-demand) -->
    @if (showDatePicker) {
      <!-- Date picker inizio -->
      <ion-item id="caf-date-start">
        <ion-label position="stacked">
          @if (action.actionType === 'assenza') {
            {{ 'shared.command_palette.form.dalGiorno' | transloco }}
          } @else {
            {{ 'shared.command_palette.form.giorno' | transloco }}
          }
        </ion-label>
        <ion-input
          [value]="ctrlDataInizio.value | date: 'dd/MM/yyyy'"
          readonly="true"
          class="ion-text-center"
          [attr.aria-label]="dataInizioAria"></ion-input>
        <ion-icon name="calendar-outline" slot="end" aria-hidden="true"></ion-icon>
        <ion-modal trigger="caf-date-start" [keepContentsMounted]="true"
          class="custom-ion-modal"
          [backdropDismiss]="false" [attr.aria-label]="selezionaDataInizioAria">
          <ng-template>
            <ion-datetime
              presentation="date"
              class="custom-datetime"
              [showDefaultButtons]="true"
              [min]="todayDate"
              [multiple]="false"
              [value]="ctrlDataInizio.value"
              [formControl]="ctrlDataInizio"
              (ionChange)="onStartChange()"
              #cafStartDatetime>
              <ion-buttons slot="buttons">
                <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="danger"
                  (click)="cafStartDatetime.cancel(); closeDateModal()">{{ annullaLabel }}</ion-button>
                <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="primary"
                  (click)="cafStartDatetime.confirm(); closeDateModal()">{{ confermaLabel }}</ion-button>
              </ion-buttons>
            </ion-datetime>
          </ng-template>
        </ion-modal>
      </ion-item>

      <!-- Date picker fine (solo assenza) -->
      @if (action.actionType === 'assenza') {
        <ion-item id="caf-date-end">
          <ion-label position="stacked">{{ 'shared.command_palette.form.alGiorno' | transloco }}</ion-label>
          <ion-input
            [value]="ctrlDataFine.value | date: 'dd/MM/yyyy'"
            readonly="true"
            class="ion-text-center"
            [attr.aria-label]="dataFineAria"></ion-input>
          <ion-icon name="calendar-outline" slot="end" aria-hidden="true"></ion-icon>
          <ion-modal trigger="caf-date-end" [keepContentsMounted]="true"
            class="custom-ion-modal"
            [backdropDismiss]="false" [attr.aria-label]="selezionaDataFineAria">
            <ng-template>
              <ion-datetime
                presentation="date"
                class="custom-datetime"
                [showDefaultButtons]="true"
                [min]="todayDate"
                [multiple]="false"
                [value]="ctrlDataFine.value"
                [formControl]="ctrlDataFine"
                (ionChange)="onEndChange()"
                #cafEndDatetime>
                <ion-buttons slot="buttons">
                  <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="danger"
                    (click)="cafEndDatetime.cancel(); closeDateModal()">{{ annullaLabel }}</ion-button>
                  <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="primary"
                    (click)="cafEndDatetime.confirm(); closeDateModal()">{{ confermaLabel }}</ion-button>
                </ion-buttons>
              </ion-datetime>
            </ng-template>
          </ion-modal>
        </ion-item>
      }

      <!-- Suggerimento neutro della selezione (assenza singola/intervallo + pasta in bianco) -->
      @if (dateHint) {
        <div class="caf-date-hint" role="note">
          <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
          <span>{{ dateHint }}</span>
        </div>
      }
    }

    <!-- Bottone salva -->
    @if (!loadingEvents) {
      <div class="ion-padding">
        <ion-button
          expand="block"
          color="primary"
          [disabled]="!canSave"
          (click)="save()"
          class="ion-text-uppercase">
          {{ saveButtonLabel }}
        </ion-button>
      </div>
    }

  </div>
</div>
